"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./WirelessCart.scss");
var ui_components_1 = require("@idp/ui-components");
var ModalProps_1 = require("@idp/ui-components/components/atoms/Modal/ModalProps");
var CartConfiguration_scss_1 = require("../../CartConfigurationContainer/CartConfiguration.scss");
var PriceContainerProps_1 = require("@idp/ui-components/components/cards/PriceContainer/PriceContainerProps");
var StateProvider_1 = require("../../../api/StateProvider");
var utils_1 = require("@idp/ui-components/utils");
var Api_1 = require("../../../api/Api");
var Utils = require("../../../utils/UtilityFunctions");
var cartUtils = require("../../../utils/CartUtilFunctions");
var CartUtilFunctions_1 = require("../../../utils/CartUtilFunctions");
var CommonUtils = require("../../../utils/CommonUtilFuntions");
var ReportingService_1 = require("../../../api/ReportingService");
var CartItemPromo_1 = require("../../atoms/CartItemPromo");
var WirelessCartPlan_1 = require("../WirelessCart/WirelessCartPlan");
var LabelProps_1 = require("@idp/ui-components/components/atoms/Label/LabelProps");
var localdatastore_1 = require("../../../config/localdatastore");
var EditCapacity_1 = require("../shared/EditCapacity");
var LegalAPI_1 = require("../../../api/LegalAPI");
var WirelessHelper_1 = require("./WirelessHelper");
var wlsUtils = require("../../../utils/WirelessUtilFunctions");
var LineItem_scss_1 = require("../../CommonCart/common/LineItem/LineItem.scss");
var components_1 = require("@idp/duc/components");
var icons = require("../../../styles/ccc-icons-cart.scss");
var wirelessRTI = require("./WirelessRTI");
var MonthlyCharges_1 = require("../../CommonCart/common/MonthlyCharges");
var CartCommonStyle = require("../../../styles/CartCommon.scss");
var CartUtilFunctions_2 = require("../../../utils/CartUtilFunctions");
var LineItem_1 = require("../../CommonCart/common/LineItem");
var WirelessContents_1 = require("./WirelessContents");
var RetailerOffer_1 = require("../../panels/RetailerOffer/RetailerOffer");
var WirelessCartHelper = /** @class */ (function (_super) {
    __extends(WirelessCartHelper, _super);
    function WirelessCartHelper(props) {
        var _this = _super.call(this, props) || this;
        _this.prepaidremoveItemsLinkLabel = 'Remove AT&T PREPAID';
        _this.bogoOfferModalLegalObj = {};
        _this.b2bDetail = {};
        _this.shippingDetails = {};
        _this.isAALFlow = false;
        _this.wlsEarlyUpgradePriceFeature = false;
        _this.isBYODAndEsim = false;
        _this.showEditOptions = false;
        _this.earlyUpgradeAmount = 0;
        _this.flagExpressUpCapacityLink = false;
        _this.lineItemArry = new Array();
        _this.expUpDueTodayItems = new Array();
        _this.expUpDueMonthlyItems = new Array();
        _this.expUpDueOnFirstBillItems = new Array();
        _this.expUpdueTodayLegal = {};
        _this.govTaxandFeeLegal = {};
        _this.expUpdueMonthlyLegal = {};
        _this.expUpdue1stBillLegal = {};
        _this.showEstDelivery = false;
        _this.expUpisMultiLine = false;
        _this.activationLineItemContent = [];
        _this.sdpData = { count: 0, price: 0 };
        _this.insuranceDetails = {};
        _this.bogoModalBlock = function () {
            return (React.createElement(ui_components_1.Modal, { testId: utils_1.default(_this.props.testId, 'Modal', 'bogoOffers'), options: {
                    center: true, className: { modalContentClass: CartConfiguration_scss_1.rennyModalCloseBtn },
                    show: _this.state.bogoSeeOfferModalDisplayed,
                    showClose: true,
                    size: ModalProps_1.ModalSizes.MEDIUM,
                    tabIndex: 0,
                }, events: { onClose: _this.closeBOGOSeeOfferModal } },
                React.createElement("div", { className: styles.legalContainer },
                    React.createElement("p", { dangerouslySetInnerHTML: {
                            __html: _this.bogoOfferModalLegalObj.longtext,
                        } }))));
        };
        _this.showWaivedText = function (lineItem) {
            if (lineItem.uiDisplayLineItem && lineItem.fees && lineItem.fees.waivedIndicator === true &&
                (lineItem.itemType.toUpperCase() !== 'UPGRADEFEE' && lineItem.itemType.toUpperCase() !== 'ACTIVATION_FEE')
                && Utils.showEarlyUpgradeLineItem(lineItem.itemType, _this.earlyUpgradeAmount)) {
                return (React.createElement("div", { className: styles.promoContainer },
                    React.createElement("div", { className: [styles.lineItems, styles.promoText].join(' ') },
                        React.createElement("div", null,
                            React.createElement(ui_components_1.Label, { testId: utils_1.default('WRLS', 'Label', "Waiver"), data: {
                                    isDecodingRequired: false,
                                    text: wlsUtils.
                                        getWaivedText(lineItem.fees.feeId, _this.b2bDetail),
                                }, options: { className: [styles.itemName, styles.promoText].join(' ') } })),
                        React.createElement("div", { className: styles.promoPrice, "data-test-id": "WRLS_Label_PriceContainerWaiver" },
                            React.createElement("span", null,
                                "-$",
                                wlsUtils.getFinalPrice(lineItem.price, lineItem.itemType, _this.isMixAndMatch))))));
            }
            else {
                return (React.createElement(React.Fragment, null, " "));
            }
        };
        _this.displayInsuranceUpdatedAlertLineLevel = function (losgs) {
            if (losgs.insuranceItemUpdated) {
                return (React.createElement("div", null, React.createElement(components_1.Alert, { closeable: false, onWhite: true, testId: utils_1.default('Cart', 'InsuranceUpdated', '_msg'), type: "success", className: styles.alertbox },
                    React.createElement(ui_components_1.Label, { data: {
                            text: _this.cartSummaryCMSData.priceUpdated,
                        }, options: {
                            className: styles.rtiErrorMsg,
                        } }),
                    React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default('addInsurance', 'Link', 'Modal'), className: styles.commonLinkSmall, icon: React.createElement(components_1.IconSvg, { size: 16, svgNodeStr: Utils.GET_ICON_SVG.UP }), 
                        // tslint:disable-next-line: jsx-no-lambda
                        onClick: function () { window.location.href = losgs.pscEditUrl; } }, _this.cartSummaryCMSData.viewPlans))));
            }
            else {
                return (React.createElement(React.Fragment, null, " "));
            }
        };
        _this.renderPlanModalDetails = function (cartData) {
            var isExpressView = _this.isExpressUp();
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: isExpressView ? styles.expupLineHeader : styles.line }, _this.cartSummaryCMSData.planLineHeading),
                React.createElement(WirelessCartPlan_1.default, { data: { wirelessCartData: cartData, expressView: isExpressView }, events: { getLegalLink: _this.matchPromoId.bind(_this) } })));
        };
        _this.displayAccessoryImage = function (lineItem) {
            var imgInfo = wlsUtils.getItemImage(lineItem);
            if (imgInfo && imgInfo.imageUrl) {
                return (React.createElement("div", { className: styles.accessoryImageContainer },
                    React.createElement("img", { src: imgInfo.imageUrl, alt: imgInfo.imgAltText })));
            }
            else {
                return null;
            }
        };
        _this.api = new Api_1.default();
        _this.legalApi = new LegalAPI_1.default();
        _this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        _this.dialog = ui_components_1.DialogService.getInstance();
        _this.reportingService = new ReportingService_1.default();
        return _this;
    }
    WirelessCartHelper.prototype.bindThisToFunctions = function () {
        this.onRemoveClick = this.onRemoveClick.bind(this);
        this.toggleRemoveModal = this.toggleRemoveModal.bind(this);
        this.acessFeeHelpBlock = this.acessFeeHelpBlock.bind(this);
        this.displayDeviceLine = this.displayDeviceLine.bind(this);
        this.showChangeOption = this.showChangeOption.bind(this);
        this.getProductSPODetails = this.getProductSPODetails.bind(this);
        this.buildRemoveCartData = this.buildRemoveCartData.bind(this);
        this.showEditAndRemove = this.showEditAndRemove.bind(this);
        this.editLineForPscCustomers = this.editLineForPscCustomers.bind(this);
        this.removeLineForPscCustomers = this.removeLineForPscCustomers.bind(this);
        this.showAttAdminFees = this.showAttAdminFees.bind(this);
        this.showlineItemPrice = this.showlineItemPrice.bind(this);
        this.renderAccessoryView = this.renderAccessoryView.bind(this);
        this.showExpUpLegalModal = this.showExpUpLegalModal.bind(this);
        this.getEstimatedMonthlySurcharges = this.getEstimatedMonthlySurcharges.bind(this);
        this.getPayupPayoffFromDeviceLineitem = this.getPayupPayoffFromDeviceLineitem.bind(this);
        this.getSalesTax = this.getSalesTax.bind(this);
    };
    WirelessCartHelper.prototype.displayEditCapacityModal = function (lineItem, losg, enableCommitmentViewDate, deviceName, subscriberNumber, linkLabel) {
        var _a, _b, _c, _d;
        var losgId = losg.id;
        var losgType = losg.losgType;
        var itemId = lineItem.id;
        var tradeinLineItem = wlsUtils.getHylaTradeInLineItem(losg);
        var hylaPromotion;
        if ((_a = this.cartData) === null || _a === void 0 ? void 0 : _a.promotions) {
            this.cartData.promotions.forEach(function (promotion) {
                var _a;
                if (promotion.promotionCategory === 'HYLA_TRADEIN' && ((_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.promotionReferences) === null || _a === void 0 ? void 0 : _a.includes(promotion.id))) {
                    hylaPromotion = promotion;
                }
            });
        }
        var estimatedValueForNewFlow = this.newWireless ? (_b = losg === null || losg === void 0 ? void 0 : losg.extraParams) === null || _b === void 0 ? void 0 : _b.hylaDiscountValue : '';
        var estimatedTradeInValue = (hylaPromotion === null || hylaPromotion === void 0 ? void 0 : hylaPromotion.amount) || (hylaPromotion === null || hylaPromotion === void 0 ? void 0 : hylaPromotion.promoDisplayAmount) ||
            estimatedValueForNewFlow;
        return Utils.hideCapacityLink((_d = (_c = this.props) === null || _c === void 0 ? void 0 : _c.options) === null || _d === void 0 ? void 0 : _d.isExpressUpgradeView, this.flagExpressUpCapacityLink) &&
            (React.createElement(EditCapacity_1.default, { cmscontent: {
                    bandColorLabel: this.cartSummaryCMSData.bandColorLabel,
                    bandSizeLabel: this.cartSummaryCMSData.bandSizeLabel,
                    bandTypeLabel: this.cartSummaryCMSData.bandTypeLabel,
                    capacityLabel: this.cartSummaryCMSData.capacityLabel,
                    caseColorLabel: this.cartSummaryCMSData.caseColorLabel,
                    caseFinishLabel: this.cartSummaryCMSData.caseFinishLabel,
                    changeCapacityWarrningMsg: this.cartSummaryCMSData.changeCapacityWarrningMsg,
                    colorLabel: this.cartSummaryCMSData.colorLabel,
                    estDeliveryLabel: this.cartSummaryCMSData.estDeliveryDateLabel,
                    headingLabel: this.cartSummaryCMSData.headingLabel,
                    saveBtnLabel: this.cartSummaryCMSData.saveBtnLabel,
                    updatedPriceWarningMsg: this.cartSummaryCMSData.updatedPriceWarningMsg,
                }, data: {
                    deviceName: deviceName,
                    estimatedDeliveryDates: wirelessRTI.displayEstDeliveryDate(lineItem, this.cartSummaryCMSData.expupEstDateLabel, true),
                    estimatedTradeInValue: estimatedTradeInValue,
                    isDFShippingSelected: this.showEstDelivery,
                    itemType: lineItem.itemType,
                    linkText: linkLabel,
                    productSKU: lineItem.productSKU,
                    showDeliveryDates: !!(enableCommitmentViewDate),
                    spoData: this.state.productDetails[lineItem.productSKU],
                    tradeinLineItem: tradeinLineItem,
                }, options: { itemId: itemId, lineItemData: lineItem, losgId: losgId, losgType: losgType, showIcon: false, subscriberNumber: subscriberNumber }, events: {
                    doLoading: this.props.events.doLoading,
                    onDeviceChange: this.props.events.onDeviceChange,
                    updateBillCodes: this.onChangeUpdateBillCodes,
                } }));
    };
    WirelessCartHelper.prototype.displayDeviceLine = function (lineItem, losg, cartData) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9;
        var isExpressUpgradeView = this.isExpressUp();
        var isWaivedActivationFee = ((_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.fees) === null || _a === void 0 ? void 0 : _a.waivedIndicator) === true &&
            ((_c = (_b = lineItem === null || lineItem === void 0 ? void 0 : lineItem.fees) === null || _b === void 0 ? void 0 : _b.waivedReason) === null || _c === void 0 ? void 0 : _c.toUpperCase()) === 'FAN';
        var isIRUCustomer = ((_d = cartData.b2bDetail) === null || _d === void 0 ? void 0 : _d.FAN) && !CartUtilFunctions_1.isSMBCustomer();
        var preOwnedLabelStyle = (!isExpressUpgradeView && !CartUtilFunctions_1.isNewWirelessPostpaidView()) ?
            [styles.expupDeliveryDate, styles.preOwnedLabel].join(' ') : styles.expupDeliveryDate;
        var preOwnedLabel = (lineItem && lineItem.preOwnedIndicator &&
            this.cartSummaryCMSData.preOwnedDeviceLabel) ?
            (React.createElement("div", { className: preOwnedLabelStyle }, this.cartSummaryCMSData.preOwnedDeviceLabel)) : '';
        var imageStyle = [icons.cccIconCart, icons.cccIconCartSignatureBookmark].join(' ');
        var isCommonMethodAvailable = wlsUtils.isCommonDeliveryMethodAvailable(this.payload);
        var lineItemPriceData = 0;
        var isEstDeliveryDate = wirelessRTI.displayEstDeliveryDate(lineItem, this.cartSummaryCMSData.expupEstDateLabel);
        var isFirstNet = CartUtilFunctions_2.isFNIntentPresent(losg);
        if (((losg === null || losg === void 0 ? void 0 : losg.losgType.toUpperCase()) === 'UP' ||
            (losg === null || losg === void 0 ? void 0 : losg.losgType.toUpperCase()) === 'AL') && (lineItem === null || lineItem === void 0 ? void 0 : lineItem.itemType.toUpperCase()) === 'DEVICE') {
            lineItemPriceData = ((_e = lineItem === null || lineItem === void 0 ? void 0 : lineItem.contractDetails) === null || _e === void 0 ? void 0 : _e.contractLength) > 1 ? (_f = lineItem === null || lineItem === void 0 ? void 0 : lineItem.contractDetails) === null || _f === void 0 ? void 0 : _f._effectiveLeaseAmount : (_g = lineItem === null || lineItem === void 0 ? void 0 : lineItem.price) === null || _g === void 0 ? void 0 : _g.amount;
        }
        if (lineItem.itemType.toUpperCase() !== 'DEVICE') {
            if (lineItem.itemType.toUpperCase() === 'ACCESSORY') {
                this.billCodesArry.push({
                    billCode: lineItem.billingCode, type: lineItem.itemType,
                });
            }
            if (lineItem.itemType.toUpperCase() === 'ONETIMETAX') {
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: styles.lineItemName, style: { width: '95%' } },
                        React.createElement("span", { className: styles.salesTaxName, "data-test-id": "WRLS_Label_EstimatedSalesTax" }, this.cartSummaryCMSData.lineOneTimeSalesTaxLabel),
                        React.createElement(components_1.Tooltip, { content: React.createElement("span", { dangerouslySetInnerHTML: {
                                    __html: this.cartSummaryCMSData.lineOneTimeSalesTaxToolTip,
                                } }), testId: utils_1.default('Tooltip', 'WRLS_EstimatedSalesTax'), className: CartConfiguration_scss_1.ducTooltip, position: "top", boxWidth: 300, offset: 75, zIndex: true },
                            React.createElement(components_1.IconSvg, { size: 16, colorClass: "color-ui-black", "aria-ariaLabel": "WRLS_Label_EstimatedSalesTax", svgNodeStr: Utils.GET_ICON_SVG.QUESTION })))));
            }
            else {
                return (React.createElement("div", null,
                    cartData.enableSignatureEnhancedExperience && isWaivedActivationFee && isIRUCustomer &&
                        !CartUtilFunctions_2.isFNIntentPresent() && !cartUtils.isFNUserWithConsumerLine() &&
                        React.createElement("span", { className: styles.iconBookmark32 }, (CartUtilFunctions_1.isAppreciationOfferPresent()) ?
                            React.createElement("img", { className: styles.appreciationIcon, src: 'https://www.att.com/idpassets/global/icons/svg/retail-financial/functional-icon_financial-security-filled_32.svg', alt: 'appreciationIcon' }) : React.createElement("i", { "aria-label": "Icon", className: imageStyle })),
                    React.createElement(ui_components_1.Label, { testId: utils_1.default('WRLS', 'Label', lineItem.id), data: {
                            isDecodingRequired: false,
                            text: Utils.getLineItemName(lineItem, false, this.isCommonCart, this.isExpressUp(), this.cartSummaryCMSData, this.cartData),
                        }, options: { className: this.isCommonCart ? LineItem_scss_1.lineItemContent : styles.itemName } }),
                    lineItem.itemType.toUpperCase() === 'FEATURE' &&
                        this.displayInsuranceUpdatedAlertLineLevel(losg)));
            }
        }
        else {
            var ctnNumber = losg && losg.extraParams && losg.extraParams.associatedCtn;
            var subscriberNumber = wlsUtils.getSubscriberNumber(losg);
            if (this.isCommonCart && lineItem.itemType.toUpperCase() === 'DEVICE' && losg.extraParams &&
                (losg.extraParams.BYOD === 'true') && (losg.extraParams.activation === 'false')) {
                var deviceInfo = lineItem.hardGood ? lineItem.hardGood.make + " " + lineItem.hardGood.model : '';
                var IMEINumber = ((_j = (_h = lineItem.hardGood) === null || _h === void 0 ? void 0 : _h.wirelessHardGoodCharacteristics) === null || _j === void 0 ? void 0 : _j.imei) ?
                    lineItem.hardGood.wirelessHardGoodCharacteristics.imei : '';
                return (React.createElement("div", { className: styles.itemName },
                    React.createElement("div", null, this.cartSummaryCMSData.universalSimLabel || 'AT&T Universal SIM'),
                    deviceInfo && React.createElement("div", null,
                        React.createElement("span", { className: styles.boldText }, this.cartSummaryCMSData.yourDeviceTextLabel),
                        " ",
                        deviceInfo,
                        " "),
                    IMEINumber && React.createElement("div", null,
                        React.createElement("span", { className: styles.boldText }, this.cartSummaryCMSData.imeiNumberLabel),
                        " ",
                        IMEINumber,
                        " ")));
            }
            else if (this.showChangeOption(lineItem, losg, subscriberNumber)) {
                var deviceName = lineItem.hardGood.make + " " + lineItem.hardGood.model;
                var incompletePlanCart_1 = false;
                var deviceInfo = deviceName + " - ";
                var linkLabel = lineItem.color + " - " + lineItem.capacity;
                this.showEstDelivery = true;
                this.showEditOptions = true;
                if (isExpressUpgradeView || CartUtilFunctions_1.isNewWirelessPostpaidView() || this.isCommonCart) {
                    deviceInfo = deviceName + " ";
                    if (this.isCommonCart) {
                        this.showEstDelivery = false;
                    }
                    else {
                        this.billCodesArry.push({
                            billCode: lineItem.billingCode,
                            type: lineItem.itemType,
                        });
                    }
                }
                if (cartData && cartData.shippingDetails && cartData.shippingDetails.shippingMethod &&
                    (cartData.shippingDetails.shippingMethod === 'dropOffShippingGroup'
                        || cartData.shippingDetails.shippingMethod === 'storePickUpShippingGroup'
                        || cartData.shippingDetails.shippingMethod === 'premiumDeliveryShippingGroup')) {
                    this.showEstDelivery = false;
                }
                if (losg === null || losg === void 0 ? void 0 : losg.requiredToCheckout) {
                    Object.values(losg === null || losg === void 0 ? void 0 : losg.requiredToCheckout).forEach(function (incompletePart) {
                        if (incompletePart === 'WLS_PLAN') {
                            incompletePlanCart_1 = true;
                        }
                    });
                }
                var esimCapableMessage = ((_k = this.eapFlowContext) === null || _k === void 0 ? void 0 : _k.simType) === 'eSIM' ? (_l = this.cartSummaryCMSData) === null || _l === void 0 ? void 0 : _l.konaESimCapable : '';
                return (React.createElement("span", null,
                    Utils.isAuthuser() && wlsUtils.isBYODAndEsim(losg) && !incompletePlanCart_1 &&
                        (!isFirstNet || isExpressUpgradeView) &&
                        (((_m = this.eapFlowContext) === null || _m === void 0 ? void 0 : _m.simType) === 'eSIM' || ((_o = this.eapFlowContext) === null || _o === void 0 ? void 0 : _o.simType) === 'pSIM')
                        && React.createElement("div", { className: styles.eapLineName }, esimCapableMessage),
                    React.createElement("div", { className: (((_p = this.eapFlowContext) === null || _p === void 0 ? void 0 : _p.simType) === 'eSIM'
                            || ((_q = this.eapFlowContext) === null || _q === void 0 ? void 0 : _q.simType) === 'pSIM') ? ''
                            : styles.crpContainer },
                        React.createElement("div", { className: (((_r = this.eapFlowContext) === null || _r === void 0 ? void 0 : _r.simType) === 'eSIM' || ((_s = this.eapFlowContext) === null || _s === void 0 ? void 0 : _s.simType) === 'pSIM') ? styles.esimDeviceName : wlsUtils.isCaribbeanFlow() ? styles.caribbeanDeviceName : styles.crpContent },
                            wlsUtils.multiUpCheck() && React.createElement("span", { className: styles.crpChangeLabel }, "New"),
                            React.createElement(ui_components_1.RichText, { testId: utils_1.default('WRLS', 'Device', 'Info'), data: { isDecodingRequired: false, text: deviceInfo } })),
                        ((losg === null || losg === void 0 ? void 0 : losg.losgType.toUpperCase()) === 'UP' || (losg === null || losg === void 0 ? void 0 : losg.losgType.toUpperCase()) === 'AL') &&
                            !incompletePlanCart_1 && !(((_t = this.eapFlowContext) === null || _t === void 0 ? void 0 : _t.simType) === 'eSIM' || ((_u = this.eapFlowContext) === null || _u === void 0 ? void 0 : _u.simType) === 'pSIM') && !this.isUnauthAccess &&
                            React.createElement("div", null,
                                React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('WRLS', 'Device', 'Info_Price_a'), data: { billingNote: ((_v = lineItem === null || lineItem === void 0 ? void 0 : lineItem.contractDetails) === null || _v === void 0 ? void 0 : _v.contractLength) !== 1 ? '/mo.' : '', price: lineItemPriceData }, options: { className: styles.crpPrice, decimalPoints: 2,
                                        overrideAccessibility: true, type: PriceContainerProps_1.PricingType.XSMALL } }))),
                    !((((_w = this.eapFlowContext) === null || _w === void 0 ? void 0 : _w.simType) === 'eSIM' || ((_x = this.eapFlowContext) === null || _x === void 0 ? void 0 : _x.simType) === 'pSIM') ||
                        incompletePlanCart_1) &&
                        this.displayEditCapacityModal(lineItem, losg, cartData.enableCommitmentViewDate, deviceName, subscriberNumber, linkLabel),
                    preOwnedLabel,
                    React.createElement("br", null),
                    (CartUtilFunctions_2.isDeviceESimEligible(losg)) && !wlsUtils.ischangeRatePlanFlow().isCrpCustomer &&
                        React.createElement("span", { className: styles.eapEsimMessage }, this.cartSummaryCMSData.konaDeviceESimCapable),
                    isEstDeliveryDate && !this.isUnauthAccess &&
                        React.createElement("div", { className: styles.expupDeliveryDate },
                            React.createElement("span", { className: styles.truckIcon },
                                React.createElement(components_1.IconSvg, { size: 16, colorClass: "color-ui-black", "aria-ariaLabel": "Truck Icon", svgNodeStr: Utils.GET_ICON_SVG.TRUCK })),
                            wirelessRTI.displayEstDeliveryDate(lineItem, this.cartSummaryCMSData.expupEstDateLabel)),
                    ((losg === null || losg === void 0 ? void 0 : losg.losgType.toUpperCase()) === 'UP' || (losg === null || losg === void 0 ? void 0 : losg.losgType.toUpperCase()) === 'AL') &&
                        incompletePlanCart_1 && this.incompleteCartMessage(losg),
                    wlsUtils.multiUpCheck() &&
                        React.createElement(WirelessContents_1.default, { losg: losg, wlsCMSData: this.cartSummaryCMSData, hidePrice: this.isUnauthAccess }),
                    wirelessRTI.displayAvailabilityMessage(lineItem, this.payload),
                    isCommonMethodAvailable && wirelessRTI.displayInventoryNotification(lineItem)));
            }
            else {
                if ((lineItem && lineItem.hardGood && lineItem.hardGood.make &&
                    lineItem.hardGood.model && !this.externalOrderSourceType) ||
                    (wlsUtils.isSimSwap(losg) && ((_z = (_y = lineItem === null || lineItem === void 0 ? void 0 : lineItem.hardGood) === null || _y === void 0 ? void 0 : _y.wirelessHardGoodCharacteristics) === null || _z === void 0 ? void 0 : _z._deviceDisplayName))) {
                    var deviceInfo = wlsUtils.isSimSwap(losg) ?
                        lineItem.displayName : lineItem.hardGood.make + " " + lineItem.hardGood.model;
                    var deviceDispName = (wlsUtils.isSimSwap(losg) && ((_1 = (_0 = lineItem.hardGood) === null || _0 === void 0 ? void 0 : _0.wirelessHardGoodCharacteristics) === null || _1 === void 0 ? void 0 : _1._deviceDisplayName)) ?
                        "" + lineItem.hardGood.wirelessHardGoodCharacteristics._deviceDisplayName : null;
                    var deviceColor = lineItem.color ? lineItem.color : '';
                    var deviceCapacity = lineItem.capacity ? "- " + lineItem.capacity : '';
                    this.showEditOptions = false;
                    var isByod = ((_2 = lineItem === null || lineItem === void 0 ? void 0 : lineItem.hardGood) === null || _2 === void 0 ? void 0 : _2.byodIndicator) &&
                        ((_4 = (_3 = lineItem === null || lineItem === void 0 ? void 0 : lineItem.hardGood) === null || _3 === void 0 ? void 0 : _3.wirelessHardGoodCharacteristics) === null || _4 === void 0 ? void 0 : _4._simType) === 'eSIM';
                    var eapDeviceName = ((_5 = this.eapFlowContext) === null || _5 === void 0 ? void 0 : _5.simType) === 'eSIM' ? (_6 = this.cartSummaryCMSData) === null || _6 === void 0 ? void 0 : _6.konaESimCapable : ((_7 = this.eapFlowContext) === null || _7 === void 0 ? void 0 : _7.simType) === 'pSIM' ? lineItem === null || lineItem === void 0 ? void 0 : lineItem.displayName : '';
                    return (React.createElement("span", null,
                        (isExpressUpgradeView || CartUtilFunctions_1.isNewWirelessPostpaidView() || this.isCommonCart) && (React.createElement("span", null,
                            Utils.isAuthuser() && wlsUtils.isBYODAndEsim(losg) &&
                                (!isFirstNet || isExpressUpgradeView) &&
                                (((_8 = this.eapFlowContext) === null || _8 === void 0 ? void 0 : _8.simType) === 'eSIM' || ((_9 = this.eapFlowContext) === null || _9 === void 0 ? void 0 : _9.simType) === 'pSIM')
                                && React.createElement("div", { className: styles.eapLineName }, eapDeviceName),
                            this.showDeviceInfo(deviceInfo, isByod, losg, lineItemPriceData, deviceDispName),
                            lineItem.hardGood.hardGoodType !== 'SIM' && (React.createElement("span", { className: styles.expupDeviceModel }, deviceColor + " " + deviceCapacity + " ")))),
                        !isExpressUpgradeView && !CartUtilFunctions_1.isNewWirelessPostpaidView() && !this.isCommonCart && (React.createElement("span", null, deviceInfo + " " + deviceColor + " " + deviceCapacity)),
                        preOwnedLabel,
                        (CartUtilFunctions_2.isDeviceESimEligible(losg)) && !wlsUtils.ischangeRatePlanFlow().isCrpCustomer
                            && this.displayKonaEsimMsg(),
                        !this.isUnauthAccess && isEstDeliveryDate &&
                            React.createElement("div", { className: styles.expupDeliveryDate },
                                React.createElement("span", { className: styles.truckIcon },
                                    React.createElement(components_1.IconSvg, { size: 16, colorClass: "color-ui-black", "aria-ariaLabel": "Truck Icon", svgNodeStr: Utils.GET_ICON_SVG.TRUCK })),
                                wirelessRTI.displayEstDeliveryDate(lineItem, this.
                                    cartSummaryCMSData.expupEstDateLabel)),
                        wlsUtils.multiUpCheck() &&
                            React.createElement(WirelessContents_1.default, { losg: losg, wlsCMSData: this.cartSummaryCMSData, hidePrice: this.isUnauthAccess }),
                        wirelessRTI.displayAvailabilityMessage(lineItem, this.payload),
                        isCommonMethodAvailable && wirelessRTI.displayInventoryNotification(lineItem)));
                }
                else {
                    if (this.externalOrderSourceType === 'BMWSMART' && lineItem.itemType.toUpperCase() === 'DEVICE'
                        && ctnNumber) {
                        var firstName = (losg.subscriberName && losg.subscriberName.firstName) ?
                            "(" + losg.subscriberName.firstName + ")" : '';
                        var deviceInfo = "Sync with " + Utils.formatPhoneNumberWithDot(ctnNumber, true) + " " + firstName;
                        return (React.createElement("span", null, deviceInfo));
                    }
                    else {
                        return (React.createElement("span", null,
                            lineItem.displayName,
                            React.createElement("br", null),
                            " ",
                            CartUtilFunctions_2.isDeviceESimEligible(losg) &&
                                !wlsUtils.ischangeRatePlanFlow().isCrpCustomer &&
                                React.createElement("span", { className: styles.eapEsimMessage }, this.cartSummaryCMSData
                                    .konaDeviceESimCapable)));
                    }
                }
            }
        }
    };
    WirelessCartHelper.prototype.showChangeOption = function (lineItem, losg, subscriberNumber) {
        var _a, _b, _c;
        if (this.checkCapacityEnabledDevices(lineItem)) {
            if (WirelessCartHelper.CALL_SPO_ONLOAD && this.spoDataAvailSkus.indexOf(lineItem.productSKU) === -1) {
                this.getProductSPODetails(lineItem, losg, subscriberNumber);
            }
            if (Utils.isEnableValidateInventory() && lineItem && lineItem.productSKU) {
                var spoData = this.state.productDetails[lineItem.productSKU];
                return ((_c = (_b = (_a = spoData === null || spoData === void 0 ? void 0 : spoData.content) === null || _a === void 0 ? void 0 : _a.wireless) === null || _b === void 0 ? void 0 : _b.itemList) === null || _c === void 0 ? void 0 : _c.length) > 1;
            }
            return true;
        }
        return false;
    };
    WirelessCartHelper.prototype.showExpUpLegalModal = function (legalview, content) {
        this.reportingService.fireLinkClickWithOutPageLoad(content, ReportingService_1.PageUrls.CARTVIEW_PAGE);
        legalview ? this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_SEE_DETAILS_DUE_TODAY_MODAL) :
            this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CARTVIEW_PAGE);
        this.setState({ showExpUpLegal: legalview });
    };
    WirelessCartHelper.prototype.showlineItemPrice = function (lineItem, isExpressUpFlow, hidePrice, isEsimFlow, isCrpUpgrade) {
        if (hidePrice) {
            return (React.createElement(React.Fragment, null, " "));
        }
        var pricingType = PriceContainerProps_1.PricingType.XSMALL;
        var lineItemPriceData = wlsUtils.getLineItemPriceData(lineItem, this.isMixAndMatch, true, isCrpUpgrade);
        lineItemPriceData.lineItemPrice.billingNote =
            isExpressUpFlow ? '' : lineItemPriceData.lineItemPrice.billingNote;
        var getPromoDetails = wlsUtils.getEffectivePromoPricing(lineItem);
        if (lineItem && lineItem.fees && lineItem.fees.feeId && lineItem.fees.waivedIndicator &&
            (lineItem.fees.feeId === 'ACT' || lineItem.fees.feeId === 'UPG')) {
            return (React.createElement(ui_components_1.Label, { testId: utils_1.default('WRLS', 'Price', 'Waived'), data: { text: 'Waived' }, options: { className: styles.itemName } }));
        }
        else if (this.isCommonCart && lineItem.productType === 'OPTIONAL_INCLUDED_FEATURE') {
            return (React.createElement(ui_components_1.Label, { testId: utils_1.default('WRLS', 'Price', 'Included'), data: { text: 'Included' }, options: { className: styles.itemName } }));
        }
        else {
            var priceStyle = this.isCommonCart ? LineItem_scss_1.lineItemPrice : styles.lineItem;
            return (React.createElement(React.Fragment, null,
                (Utils.displayLineItemPrice(lineItem, this.eapFlowContext.isEAPFlow)
                    || isEsimFlow) &&
                    React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('WRLS', "lineItem_" + lineItem.id), data: lineItemPriceData.lineItemPrice, options: { className: priceStyle, decimalPoints: 2, type: pricingType } }),
                getPromoDetails && getPromoDetails.isPromoLineItem &&
                    getPromoDetails.effectiveDevicePrice === 0 &&
                    React.createElement(ui_components_1.Label, { testId: utils_1.default('WRLS', 'Price', 'Free'), data: { text: 'FREE' }, options: { className: styles.itemName } }),
                getPromoDetails && getPromoDetails.isPromoLineItem && getPromoDetails.effectiveDevicePrice > 0 &&
                    React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('WRLS', 'Promo', 'Price'), data: {
                            billingNote: lineItemPriceData.lineItemPrice.billingNote,
                            price: getPromoDetails.effectiveDevicePrice,
                        }, options: { className: priceStyle, decimalPoints: 2, type: pricingType } }),
                getPromoDetails && getPromoDetails.isPromoLineItem && getPromoDetails.effectiveDevicePrice < 0 &&
                    React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('WRLS', 'Promo', 'Price'), data: {
                            billingNote: lineItemPriceData.lineItemPrice.billingNote,
                            price: Math.abs(getPromoDetails.effectiveDevicePrice),
                        }, options: {
                            className: priceStyle, decimalPoints: 2, isDataPriceNegative: true,
                            type: pricingType,
                        } })));
        }
    };
    WirelessCartHelper.prototype.showAttAdminFees = function (payload) {
        var longLegalText = (this.govTaxandFeeLegal && this.govTaxandFeeLegal.longtext) ?
            this.govTaxandFeeLegal.longtext : '';
        var wirelessAdministrativeFee;
        var wirelessRegulatoryCost;
        var addOnDueAmount;
        if (payload) {
            wirelessAdministrativeFee = (payload.wirelessAdministrativeFee) ? payload.wirelessAdministrativeFee : 0;
            wirelessRegulatoryCost = (payload.wirelessRegulatoryCost) ? payload.wirelessRegulatoryCost : 0;
            addOnDueAmount = (payload.addOnDueAmount) ? payload.addOnDueAmount : 0;
        }
        var totalAmount = (wirelessRegulatoryCost && wirelessAdministrativeFee) ?
            wirelessRegulatoryCost + wirelessAdministrativeFee : 0;
        if (addOnDueAmount !== 0) {
            return (React.createElement(React.Fragment, null,
                !this.isExpressUp() && React.createElement("div", { className: styles.solidLightGray }),
                React.createElement("div", null,
                    React.createElement("div", { className: styles.lineItems },
                        React.createElement("div", { className: styles.lineItemName },
                            React.createElement(ui_components_1.RichText, { testId: utils_1.default('WLS', 'Label', 'ATTFees'), data: {
                                    text: (this.cartSummaryCMSData.titleATTFees) ?
                                        this.cartSummaryCMSData.titleATTFees : '',
                                } })),
                        React.createElement("div", { className: styles.lineItemPrice },
                            React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('WLS', 'attAdmin', 'FeesAmount'), data: { billingNote: this.isExpressUp() ? '' : '/mo.', price: addOnDueAmount }, options: {
                                    className: styles.lineItem,
                                    decimalPoints: 2,
                                    type: PriceContainerProps_1.PricingType.XSMALL,
                                } }))),
                    React.createElement("div", { className: styles.lineItemName },
                        React.createElement("div", { className: styles.monthlyPayments },
                            React.createElement(ui_components_1.RichText, { testId: utils_1.default('WLS', 'Label', 'attFeesPerLine'), data: {
                                    text: (this.cartSummaryCMSData.feesAmtSubTextLabel
                                        && totalAmount !== 0) ? this.cartSummaryCMSData.feesAmtSubTextLabel.
                                        replace('{0}', "$" + totalAmount.toString()) : '',
                                } })),
                        this.govTaxandFeeLegal && this.govTaxandFeeLegal.shorttext &&
                            React.createElement("div", { className: styles.attfeesDisclaimer },
                                React.createElement(ui_components_1.RichText, { testId: utils_1.default('WLS', 'Label', 'govTaxDisclaimer'), data: { text: this.govTaxandFeeLegal.shorttext } }),
                                "\u00A0",
                                React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default('WLS', 'Link', 'govTaxAndFees'), onClick: this.showAttFeesDetail, "aria-label": this.govTaxandFeeLegal.shortdesclinktext + " link of govTaxAndFees", className: [styles.expupLegallink, CartConfiguration_scss_1.detailsCommonLink].join(' ') }, (this.govTaxandFeeLegal && this.govTaxandFeeLegal.shortdesclinktext) ?
                                    this.govTaxandFeeLegal.shortdesclinktext : '')))),
                this.govTaxandFeeLegal && this.govTaxandFeeLegal.modaltitle &&
                    React.createElement(ui_components_1.Modal, { testId: utils_1.default('WLS', 'Modal', 'govTaxDisclaimer'), options: {
                            center: true, className: { modalContentClass: CartConfiguration_scss_1.rennyModalCloseBtn },
                            show: this.state.isModalOpen,
                            showClose: true,
                            size: ModalProps_1.ModalSizes.MEDIUM,
                            tabIndex: 0,
                        }, events: { onClose: this.closeAttFeesDetail } },
                        React.createElement("div", { className: styles.legalAttfeesContainer },
                            React.createElement(ui_components_1.Label, { data: { text: this.govTaxandFeeLegal.modaltitle }, options: { size: LabelProps_1.LabelSizes.SMALLHEADING24, className: styles.legalHeading } }),
                            React.createElement("p", { dangerouslySetInnerHTML: { __html: longLegalText } })))));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    WirelessCartHelper.prototype.getSalesTax = function (tax, orderPriceInfo, billingCycle, losg) {
        if (this.isCommonCart && losg && losg.losgTaxInfo && losg.losgTaxInfo.taxData) {
            return this.getEstimatedMonthlySurcharges(losg, tax, this.filteredLosgsData);
        }
        else {
            var tooTipContent = '';
            var taxAmt = void 0;
            var isTax = (orderPriceInfo && tax !== undefined && tax !== null) ? orderPriceInfo.taxCalculated : false;
            if (isTax) {
                tooTipContent = this.isCommonCart ?
                    this.cartSummaryCMSData.bsseTaxApiUp : this.cartSummaryCMSData.taxApiUp;
                taxAmt = (React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('WRLS', 'PriceContainer', 'EstimatedSalesTax'), data: { billingNote: billingCycle ? billingCycle : '', price: tax }, options: { decimalPoints: 2, type: PriceContainerProps_1.PricingType.XSMALL, className: styles.salesTaxPrice } }));
            }
            else {
                tooTipContent = this.isCommonCart ?
                    this.cartSummaryCMSData.bsseTaxApiUp : this.cartSummaryCMSData.taxApiDown;
                var finalTaxAmount = this.isBYODAndEsim ? '$0.00' : '$--.--';
                taxAmt = (React.createElement("div", null,
                    React.createElement(ui_components_1.Label, { testId: utils_1.default('WRLS', 'PriceContainer', 'EmptyTaxText'), data: { text: finalTaxAmount }, options: { className: styles.salesTaxPrice } })));
            }
            var taxContent = (React.createElement(React.Fragment, null,
                React.createElement("div", { className: styles.lineItemName },
                    React.createElement("span", { className: styles.salesTaxName, "data-test-id": "WRLS_Label_EstimatedSalesTax" },
                        !this.isCommonCart && this.cartSummaryCMSData.estimatedSalesTax,
                        this.isCommonCart && this.cartSummaryCMSData.bsseEstimatedSalesTax),
                    React.createElement(components_1.Tooltip, { content: React.createElement("span", { dangerouslySetInnerHTML: { __html: tooTipContent } }), testId: utils_1.default('Tooltip', 'WRLS_EstimatedSalesTax'), className: CartConfiguration_scss_1.ducTooltip, position: "top", boxWidth: 300, offset: 75, zIndex: true },
                        React.createElement(components_1.IconSvg, { size: 16, colorClass: "color-ui-black", svgNodeStr: Utils.GET_ICON_SVG.QUESTION }))),
                React.createElement("div", { className: styles.lineItemPrice },
                    " ",
                    taxAmt,
                    " ")));
            return taxContent;
        }
    };
    WirelessCartHelper.prototype.getEstimatedMonthlySurcharges = function (losg, totalTax, losgs) {
        if (losg && losg.losgTaxInfo && losg.losgTaxInfo.taxData) {
            var linkText = this.cartSummaryCMSData.monthlyChargesLinkLabel || 'See cost breakdown';
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: CartCommonStyle.lineItemContent, style: { paddingRight: '10px' } },
                    React.createElement("span", null, this.cartSummaryCMSData.monthlyChargesLabel + " "),
                    losg.losgTaxInfo.taxData.length > 0 && React.createElement("span", null,
                        React.createElement(MonthlyCharges_1.default, { data: { linkText: linkText, losgs: losgs, losgsId: losg.id, wlsCmsContent: this.cartSummaryCMSData } }))),
                React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('WRLS', "lineItem_Cost_Breakdown"), data: { billingNote: '/mo.', price: totalTax }, options: { className: styles.lineItem, decimalPoints: 2, type: PriceContainerProps_1.PricingType.XSMALL } })));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    WirelessCartHelper.prototype.acessFeeHelpBlock = function () {
        return (React.createElement(ui_components_1.Modal, { testId: utils_1.default(this.props.testId, 'Modal', 'accessFeeHelp'), options: {
                center: true, className: { modalContentClass: CartConfiguration_scss_1.rennyModalCloseBtn },
                show: this.state.accessFeeHelpModalDisplay,
                showClose: true,
                size: ModalProps_1.ModalSizes.MEDIUM,
                tabIndex: 0,
            }, events: { onClose: this.closeAccessFeeHelpModal } },
            React.createElement("div", { className: styles.legalContainer },
                React.createElement(ui_components_1.Label, { data: { text: this.cartSummaryCMSData.accessFeeHelpModalHeading }, options: { size: LabelProps_1.LabelSizes.SMALLHEADING24, className: styles.legalHeading } }),
                React.createElement("p", { dangerouslySetInnerHTML: {
                        __html: this.cartSummaryCMSData.accessFeeHelpModalLine1,
                    } }),
                React.createElement("p", { dangerouslySetInnerHTML: {
                        __html: this.cartSummaryCMSData.accessFeeHelpModalLine2,
                    } }),
                React.createElement("p", { dangerouslySetInnerHTML: {
                        __html: this.cartSummaryCMSData.accessFeeHelpModalLine3,
                    } }))));
    };
    WirelessCartHelper.prototype.showRetailerOffer = function (losg) {
        var _a, _b;
        var retailer = (_b = (_a = this.cartData) === null || _a === void 0 ? void 0 : _a.promotions) === null || _b === void 0 ? void 0 : _b.map(function (promo) {
            if ((promo === null || promo === void 0 ? void 0 : promo._dealerPromotion) && promo.promotionType.toUpperCase() !== 'REWARD') {
                return React.createElement(RetailerOffer_1.default, { isReawardCard: false, losg: losg, promotion: promo });
            }
        });
        return React.createElement("div", null, retailer);
    };
    WirelessCartHelper.prototype.showPromotions = function (lineItem, promoDisplay) {
        var _this = this;
        var _a;
        if (lineItem.promotionReferences && lineItem.itemType.toUpperCase() !== 'SHAREDDATAGROUP' &&
            lineItem.itemType.toUpperCase() !== 'SHAREDDATAFEATURE'
            && this.cartData.promotions && this.cartData.promotions.length > 0 && !promoDisplay &&
            Utils.showEarlyUpgradeLineItem(lineItem.itemType, this.earlyUpgradeAmount)) {
            var cartPromos = lineItem.promotionReferences.map(function (promoRef, index) {
                return _this.cartData.promotions.find(function (promo) { return promo.id === promoRef; });
            });
            if (this.payload.enableSplitAccessoryLine && ((_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.itemType) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'accessory'
                && lineItem.quantity > 1) {
                cartPromos = CommonUtils.getUpdatedMultipleAccessoryPromos(cartPromos);
            }
            return (cartPromos.map(function (promotion, promoIndex) {
                var _a, _b, _c, _d, _e;
                var promoPriceData = {
                    billingNote: (promotion === null || promotion === void 0 ? void 0 : promotion.promotionCycle) && ((_a = promotion === null || promotion === void 0 ? void 0 : promotion.promotionCycle) === null || _a === void 0 ? void 0 : _a.toString()),
                    price: promotion === null || promotion === void 0 ? void 0 : promotion.amount,
                };
                var showPriceAmt = true;
                var promotionId = '';
                var promoType = promotion.promotionType ? (_b = promotion.promotionType) === null || _b === void 0 ? void 0 : _b.toUpperCase() : '';
                var promoCategory = promotion.promotionCategory ? (_c = promotion.promotionCategory) === null || _c === void 0 ? void 0 : _c.toUpperCase() : '';
                if (promotion.promotionCategory === 'STACKABLE_STANDALONE_PROMO'
                    || promotion._intent === 'private') {
                    promotionId = promotion.upsellOfferId ? promotion.upsellOfferId : promotion.promotionId;
                }
                else {
                    promotionId = promotion.cmsPromotionId ?
                        promotion.cmsPromotionId : promotion.promotionId;
                }
                if (promoType === 'BILLCREDITWITHQUALIFIER' || promoType === 'MANUALBILLCREDIT' ||
                    promoCategory === 'HYLA_TRADEIN' || promoCategory === 'HYLA_TRADEIN_PORTIN' ||
                    promoCategory === 'TRADEIN') {
                    showPriceAmt = false;
                }
                return (React.createElement("div", { key: "lineItemPromo" + promoIndex },
                    React.createElement("div", { className: styles.promoContainer },
                        React.createElement(CartItemPromo_1.default, { data: {
                                isExpressUpgradeView: (_this.isExpressUp() || _this.isCommonCart),
                                isPriceNegative: true,
                                isSignaturePromo: ((_d = _this.payload) === null || _d === void 0 ? void 0 : _d.enableSignatureEnhancedExperience) &&
                                    ((promotion === null || promotion === void 0 ? void 0 : promotion.promotionCategory) === 'iruPlanDiscount'
                                        || ((_e = promotion.discountCategory) === null || _e === void 0 ? void 0 : _e.toLowerCase()) === 'noncontractual'),
                                promoPrice: promotion.amount,
                                promoText: promotion.promotionName,
                                promotionCycle: promoPriceData.billingNote,
                                showPrice: Number(promotion === null || promotion === void 0 ? void 0 : promotion.amount) && showPriceAmt,
                            }, options: { testId: utils_1.default('WRLS', "LineItem" + promoIndex) } })),
                    _this.matchPromoId(promotionId, promotion.promotionCategory)));
            }));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    WirelessCartHelper.prototype.getActivationLineItemContent = function (lineItem, index) {
        var pricingType = PriceContainerProps_1.PricingType.XSMALL;
        if (lineItem && (this.isAALFlow || this.isMixedCart) &&
            lineItem.itemType.toUpperCase() === 'SHAREDDATAFEATURE' && lineItem.uiDisplayLineItem) {
            var lineItemPriceData = wlsUtils.getLineItemPriceData(lineItem, this.isMixAndMatch, true);
            var activationLineClass = (lineItem.fees && lineItem.fees.feeId === 'ACT') ? styles.
                activationLineItem : '';
            if (this.isExpressUp()) {
                lineItemPriceData.lineItemPrice.billingNote = '';
            }
            this.activationLineItemContent.push(React.createElement("div", { className: this.isExpressUp() ? styles.expupLineitemContainer : '' },
                React.createElement("div", { className: [styles.lineItems, activationLineClass, styles.accessLine].join(' ') },
                    React.createElement("div", null,
                        React.createElement(ui_components_1.Label, { data: {
                                isDecodingRequired: false,
                                text: "Line " + (index + 1) + " -\n                                    " + this.cartSummaryCMSData.shareFeatureLabel,
                            }, options: { className: styles.itemName } })),
                    lineItem.price &&
                        React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('WRLS', "lineItem_" + index), data: lineItemPriceData.lineItemPrice, options: { className: styles.lineItem, decimalPoints: 2, type: pricingType } })),
                lineItem.promotionReferences && (lineItem.itemType.toUpperCase() === 'SHAREDDATAFEATURE') &&
                    this.cartData.promotions && this.cartData.promotions.length > 0 &&
                    this.checkDuplicatePromo(lineItem)));
        }
    };
    WirelessCartHelper.prototype.showInstallmentMessage = function (lineItem, losg) {
        var _a, _b;
        if (lineItem && !this.externalOrderSourceType) {
            var lineItemPriceData = wlsUtils.getLineItemPriceData(lineItem, this.isMixAndMatch, true);
            var getPromoDetails = wlsUtils.getEffectivePromoPricing(lineItem);
            var isEsimFlow = wlsUtils.isBYODAndEsim(losg);
            var newWireless = cartUtils.isNewWirelessPostpaidView();
            var devicePrice = newWireless && this.showlineItemPrice(lineItem, false, ((this.isCommonCart) && lineItem.itemType.toUpperCase() === 'DEVICE'), isEsimFlow);
            var messageStyle = newWireless ?
                [styles.lineItems, styles.linename, styles.postpaidLineItem].join(' ') :
                [styles.lineItems, styles.monthlyPayments].join(' ');
            var installmentLineStyle = newWireless ? styles.installmentMessage : '';
            var styleIfDownPaymetn = (newWireless || !this.downPaymentInfo.isDownPayment) ? '' : CartConfiguration_scss_1.pt10;
            var isHylaTradeInOffer = ((_a = this.cartData) === null || _a === void 0 ? void 0 : _a.promotions) && ((_b = this.cartData) === null || _b === void 0 ? void 0 : _b.promotions.find(function (promo) { return promo.promotionCategory === 'HYLA_TRADEIN'; }));
            var promoDiscountAmount = isHylaTradeInOffer === null || isHylaTradeInOffer === void 0 ? void 0 : isHylaTradeInOffer.promoDiscountAmount;
            if (lineItem.contractDetails && lineItem.contractDetails.contractType === 'NOCOMMIT' &&
                (!this.eapFlowContext.isEAPFlow || isEsimFlow)) {
                if (this.isCommonCart && lineItem.itemType.toUpperCase() === 'DEVICE' && lineItem.hardGood &&
                    lineItem.hardGood.hardGoodType && lineItem.hardGood.hardGoodType.toUpperCase() === 'DEVICE') {
                    return (React.createElement(React.Fragment, null, " "));
                }
                else {
                    return (React.createElement("div", { id: utils_1.default('WRLS', 'Contract', 'Details'), className: messageStyle },
                        React.createElement("span", { className: [installmentLineStyle, styleIfDownPaymetn].join(' ') }, this.cartSummaryCMSData.noAnnualContractLabel),
                        devicePrice));
                }
            }
            else if (!(getPromoDetails && getPromoDetails.isPromoLineItem) &&
                lineItemPriceData.monthlyPayments !== 0 && !this.isUnauthAccess) {
                return (React.createElement("div", { className: messageStyle },
                    React.createElement("span", { className: [installmentLineStyle, styleIfDownPaymetn, styles.width80p].join(' ') }, this.installmentMessage(lineItemPriceData.monthlyPayments, getPromoDetails.effectiveDevicePrice, getPromoDetails.isPromoLineItem, false, lineItem)),
                    devicePrice));
            }
            else if ((getPromoDetails && getPromoDetails.isPromoLineItem) && lineItem.contractDetails &&
                lineItem.contractDetails.installmentAmount && !this.isUnauthAccess) {
                return (React.createElement("div", { id: utils_1.default('WRLS', 'Promo', 'Subtext'), className: messageStyle },
                    React.createElement("span", { className: [installmentLineStyle, styleIfDownPaymetn, styles.width80p].join(' ') }, this.installmentMessage(lineItemPriceData.monthlyPayments, getPromoDetails.effectiveDevicePrice, getPromoDetails.isPromoLineItem, true, lineItem, promoDiscountAmount)),
                    devicePrice));
            }
            else {
                return (React.createElement(React.Fragment, null, " "));
            }
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    WirelessCartHelper.prototype.showlineItemContent = function (lineItem, losg, lineDisplayHeaderText) {
        var _a, _b, _c, _d;
        if (this.downPaymentInfo.isDownPayment && lineItem.itemType.toUpperCase() === 'DOWNPAYMENT') {
            return (React.createElement(React.Fragment, null, " "));
        }
        var itemDeviceNameStyle;
        if (this.newWireless) {
            var deviceNameStyle = (((_a = this.eapFlowContext) === null || _a === void 0 ? void 0 : _a.simType) === 'eSIM' ||
                ((_b = this.eapFlowContext) === null || _b === void 0 ? void 0 : _b.simType) === 'pSIM') ? styles.eapDeviceName : styles.deviceName;
            itemDeviceNameStyle = lineItem.itemType.toUpperCase() === 'DEVICE' ?
                [deviceNameStyle, styles.flexView].join(' ') : styles.deviceName;
        }
        else {
            itemDeviceNameStyle = styles.itemDeviceName;
        }
        var activationLineClass = ((lineItem.fees && lineItem.fees.feeId === 'ACT') ||
            (this.isMixAndMatch) && lineItem.productSubType === 'Insurance') ? styles.activationLineItem : '';
        var postpaidLineItem = (lineItem.itemType.toUpperCase() !== 'DEVICE' &&
            lineItem.itemType.toUpperCase() !== 'ACCESSORY') ? styles.postpaidLineItem : '';
        var imgInfo = wlsUtils.getItemImage(lineItem, losg, this.isCommonCart);
        if (this.isCommonCart) {
            var itemType = lineItem.itemType && lineItem.itemType.toUpperCase();
            var losgEditUrl = losg.editUrl || this.commonCartEditUrl;
            var removeInfo = {
                lineItem: (itemType === 'DEVICE') ? lineItem : {}, losgInfo: losg,
                losgsCount: this.filteredLosgsData.length,
                showEditAndRemove: (itemType === 'DEVICE') ? true : false,
            };
            var lineDeviceDetails = this.displayDeviceLine(lineItem, losg, this.payload);
            var devicePriceAndInfo = !!(itemType === 'DEVICE' && wlsUtils.showDevicePriceAndInfo(lineItem, losg, this.isCommonCart));
            var contractType = lineItem.contractDetails && lineItem.contractDetails.contractType || 'NA';
            var contractTypeMessage = devicePriceAndInfo ? (contractType.toUpperCase() === 'NOCOMMIT' ?
                this.cartSummaryCMSData.fullRetailPriceLabel : this.cartSummaryCMSData.noAnnualContractLabel) : '';
            return (React.createElement(React.Fragment, null,
                React.createElement(LineItem_1.default, { data: {
                        altText: imgInfo && imgInfo.imgAltText || '',
                        deviceDetails: lineDeviceDetails,
                        headingText: (itemType === 'DEVICE') ? lineDisplayHeaderText : '',
                        imageUrl: imgInfo && imgInfo.imageUrl || '',
                        itemPriceInfo: this.showlineItemPrice(lineItem, false, (this.isCommonCart && itemType === 'DEVICE')),
                        showImage: (itemType === 'DEVICE') ? true : false,
                        showLineItem: true,
                    }, events: {
                        onItemEdit: this.editLineForPscCustomers,
                        onItemRemove: this.removeLineForPscCustomers,
                    }, options: { editUrl: losgEditUrl, removeInfo: removeInfo } }),
                devicePriceAndInfo && React.createElement(LineItem_1.default, { data: {
                        altText: imgInfo && imgInfo.imgAltText || '',
                        deviceDetails: React.createElement("span", null, contractTypeMessage),
                        headingText: '', imageUrl: imgInfo && imgInfo.imageUrl || '',
                        itemPriceInfo: this.showlineItemPrice(lineItem, false, false),
                        showImage: false, showLineItem: true,
                    }, events: {}, options: {} })));
        }
        else {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: [styles.lineItems, activationLineClass, !this.
                            newWireless ? styles.lineItemContainer : '',
                        this.newWireless ? postpaidLineItem : ''].join(' ') },
                    React.createElement("div", { className: (this.newWireless &&
                            !(((_c = this.eapFlowContext) === null || _c === void 0 ? void 0 : _c.simType) === 'eSIM' || ((_d = this.eapFlowContext) === null || _d === void 0 ? void 0 : _d.simType) === 'pSIM')) ?
                            styles.postpaidLineItemName : styles.lineItemName },
                        !this.isCommonCart && !((lineItem.itemType.toUpperCase() === 'ACCESSORY' ||
                            lineItem.itemType.toUpperCase() === 'HYLA_TRADEIN')) &&
                            React.createElement("span", { className: itemDeviceNameStyle }, this.
                                displayDeviceLine(lineItem, losg, this.payload)),
                        this.accessoryModal(lineItem, losg, this.isUnauthAccess)),
                    this.showlineItemPrice(lineItem, false, (this.newWireless &&
                        (lineItem.itemType.toUpperCase() === 'DEVICE' ||
                            lineItem.itemType.toUpperCase() === 'HYLA_TRADEIN'))))));
        }
    };
    WirelessCartHelper.prototype.getAccessoryFragments = function (losgItems, losg, lineDisplayHeaderText) {
        var _this = this;
        var accessoryLineItem = [];
        var accessoryElement;
        losgItems.forEach(function (lineItem, secindex) {
            var _a;
            var keyId = "deviceInfo" + losg.id + "_" + secindex;
            if (lineItem.uiDisplayLineItem && lineItem.itemType.toUpperCase() === 'ACCESSORY' && !_this.isUnauthAccess) {
                accessoryElement = (React.createElement("div", { key: keyId },
                    React.createElement("div", { className: styles.flexView },
                        _this.showlineItemContent(lineItem, losg, lineDisplayHeaderText),
                        _this.isCommonCart && React.createElement("div", { className: styles.expupDeliveryDate }, wirelessRTI.displayEstDeliveryDate(lineItem, _this.cartSummaryCMSData.expupEstDateLabel))),
                    _this.showPromotions(lineItem),
                    React.createElement("div", { className: [styles.lineItemContainer, styles.lineItems, styles.taxLineItem].join(' ') }, _this.getSalesTax((_a = lineItem.price) === null || _a === void 0 ? void 0 : _a.tax, _this.payload.orderPriceInfo))));
                accessoryLineItem.push(accessoryElement);
            }
        });
        return accessoryLineItem;
    };
    WirelessCartHelper.prototype.showCartView = function (lineItemDisplay, losg, accesoryRtiOosMessage, rtiOosDeviceMessage, imageContainer, lineDisplayName, deviceName, index, retalPrice, deviceTax, accessoryDisplay, accessoryImageContainer, accessoryPriceView, isDeviceItems, lineItem, accessoryLineItems, isMDPPInsurance) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var lineDisplayCss = [styles.newLosg, styles.displayFlex,
            isDeviceItems.length === 0 && styles.authUserNewlosg];
        if (lineItemDisplay && losg) {
            var errorMessage = losg && this.incompleteCartMessage(losg);
            var isDeviceMissing = losg && wlsUtils.isDeviceMissing(losg);
            var taxItem = (deviceTax !== undefined) ? deviceTax : losg.tax;
            this.isBYODAndEsim = wlsUtils.isBYODAndEsim(losg);
            var isESimWithAcc = ((_a = losg === null || losg === void 0 ? void 0 : losg.losgType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'ACC' && ((_b = this.eapFlowContext) === null || _b === void 0 ? void 0 : _b.simType) === 'eSIM';
            var displayEstimatedTax = !this.isExpressUp() && this.externalOrderSourceType !== 'BMWSMART' && (React.createElement("div", { className: [styles.lineItemContainer, styles.lineItems, styles.taxLineItem].join(' ') }, this.getSalesTax(taxItem, this.payload.orderPriceInfo)));
            if (Utils.IsWirelessInCart() || this.isCommonCart) {
                var eapDeviceName = ((_c = this.eapFlowContext) === null || _c === void 0 ? void 0 : _c.simType) === 'eSIM' ? (_d = this.cartSummaryCMSData) === null || _d === void 0 ? void 0 : _d.konaESimCapable : ((_e = this.eapFlowContext) === null || _e === void 0 ? void 0 : _e.simType) === 'pSIM' ?
                    this.cartSummaryCMSData.konaPhysicalSim : '';
                var deviceNameStyle = (((_f = this.eapFlowContext) === null || _f === void 0 ? void 0 : _f.simType) === 'eSIM' ||
                    ((_g = this.eapFlowContext) === null || _g === void 0 ? void 0 : _g.simType) === 'pSIM') ? styles.eapDeviceName : styles.deviceName;
                var newPostPaidView = (React.createElement("div", null,
                    index > 1 && React.createElement("div", { className: styles.expupDivider }),
                    !this.isCommonCart && React.createElement(React.Fragment, null,
                        rtiOosDeviceMessage,
                        !isESimWithAcc &&
                            React.createElement("span", { className: styles.blockView },
                                React.createElement("b", { className: styles.displayBold }, lineDisplayName)),
                        React.createElement("div", { className: lineDisplayCss.join(' ') },
                            !isDeviceMissing ? imageContainer : React.createElement("span", { className: styles.deviceImageContainer }, React.createElement("i", { className: [icons.cccIconCart, icons.cccIconCartMissingDevice,
                                    styles.phoneCaseIcon].join(' '), role: "img" })),
                            React.createElement("div", { className: (this.externalOrderSourceType !== 'BMWSMART')
                                    ? styles.deviceDetailContainer : styles.deviceDetailContainerBmw },
                                isDeviceItems.length > 0 && !isESimWithAcc &&
                                    React.createElement("span", { className: styles.flexView },
                                        lineDisplayName,
                                        " "),
                                wlsUtils.isBYODAndEsim(losg) && (((_h = this.eapFlowContext) === null || _h === void 0 ? void 0 : _h.simType) === 'eSIM'
                                    || ((_j = this.eapFlowContext) === null || _j === void 0 ? void 0 : _j.simType) === 'pSIM')
                                    && React.createElement("span", { className: styles.eapLineName }, eapDeviceName),
                                (this.externalOrderSourceType !== 'BMWSMART') &&
                                    React.createElement("span", { className: [deviceNameStyle, styles.blockView].join(' ') },
                                        deviceName,
                                        " ",
                                        retalPrice),
                                errorMessage,
                                React.createElement("div", { className: styles.flexView },
                                    lineItemDisplay,
                                    this.showRetailerOffer(losg),
                                    isDeviceItems.length > 0 && displayEstimatedTax),
                                this.payload.enableDisplayHylaSharedComponent &&
                                    React.createElement("div", { className: styles.flexView },
                                        this.
                                            renderTradeInComponent(losg, lineItem),
                                        " "),
                                this.enableWirelessInsurance(losg) &&
                                    React.createElement("div", { className: styles.flexView },
                                        " ",
                                        this.
                                            renderInsurance(losg, lineItem, isMDPPInsurance),
                                        " "))),
                        React.createElement("div", { className: styles.blockView },
                            lineItemDisplay,
                            this.showRetailerOffer(losg),
                            displayEstimatedTax),
                        this.payload.enableDisplayHylaSharedComponent &&
                            React.createElement("div", { className: styles.blockView },
                                " ",
                                this.renderTradeInComponent(losg, lineItem),
                                " "),
                        this.enableWirelessInsurance(losg) &&
                            React.createElement("div", { className: styles.blockView },
                                this.renderInsurance(losg, lineItem, isMDPPInsurance),
                                " "),
                        accessoryImageContainer !== undefined &&
                            this.renderAccessoryView(accessoryImageContainer, accesoryRtiOosMessage, accessoryDisplay, accessoryPriceView, isDeviceItems, lineDisplayName, wlsUtils.isAccessory(losg.losgType, this.cartData._cartCreationSource, this.isAALFlow), losg, this.cartData, this.filteredLosgsData, accessoryLineItems)),
                    this.isCommonCart && React.createElement(React.Fragment, null,
                        React.createElement("div", { className: [styles.newLosg, styles.displayFlex].join(' ') },
                            React.createElement("div", { className: styles.contentLeft },
                                " ",
                                imageContainer,
                                " "),
                            React.createElement("div", { className: styles.contentRight },
                                errorMessage,
                                " ",
                                lineItemDisplay,
                                React.createElement("div", { className: [styles.lineItemContainer, styles.lineItems,
                                        styles.taxLineItem].join(' ') },
                                    this.showRetailerOffer(losg),
                                    React.createElement("div", null, this.getSalesTax(CommonUtils.getBsseTax(losg, 'RC'), this
                                        .payload.orderPriceInfo, '/mo.', losg))))))));
                return newPostPaidView;
            }
            else {
                return (React.createElement("div", { className: styles.losg },
                    lineDisplayName,
                    errorMessage,
                    lineItemDisplay,
                    displayEstimatedTax));
            }
        }
        return (React.createElement(React.Fragment, null, " "));
    };
    WirelessCartHelper.prototype.getPayupPayoffFromDeviceLineitem = function (losgsInfo) {
        var _this = this;
        return (losgsInfo.map(function (losg) {
            var _a, _b;
            var deviceLineItem = cartUtils.getDeviceDetailsFromLOSG(losg.id);
            var devicePayupAmount = (_a = deviceLineItem === null || deviceLineItem === void 0 ? void 0 : deviceLineItem.contractDetails) === null || _a === void 0 ? void 0 : _a.payupAmount;
            var devicePayoffAmount = (_b = deviceLineItem === null || deviceLineItem === void 0 ? void 0 : deviceLineItem.contractDetails) === null || _b === void 0 ? void 0 : _b.payoffAmount;
            var payupPayoffCMSString = devicePayupAmount ? _this.cartSummaryCMSData.payUpLineItemLabel :
                (devicePayoffAmount ? _this.cartSummaryCMSData.payOffLineItemLabel : null);
            return ((devicePayupAmount || devicePayoffAmount) && (React.createElement("div", { className: styles.payupPayoffBlock },
                React.createElement(ui_components_1.Label, { data: { isDecodingRequired: false, text: payupPayoffCMSString }, options: { className: styles.itemName } }),
                React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('WRLS', "PayupPayoffItem"), data: { billingNote: '', price: (devicePayupAmount || devicePayoffAmount) }, options: { className: styles.lineItem, decimalPoints: 2, type: PriceContainerProps_1.PricingType.XSMALL } }))));
        }));
    };
    WirelessCartHelper.prototype.matchPromoId = function (cmsPromoId, promotionCategory) {
        var _a, _b, _c;
        var promotionIdexist = false;
        var legalURL = null;
        var offers = (promotionCategory === 'HYLA_TRADEIN') ?
            this.cartSummaryCMSData.hylaTradeInOffers.offers : this.cartSummaryCMSData.offers.offers;
        if (cmsPromoId && offers && offers.length > 0) {
            for (var _i = 0, offers_1 = offers; _i < offers_1.length; _i++) {
                var offer = offers_1[_i];
                if ((offer.promotionID === cmsPromoId || offer.offerID === cmsPromoId) &&
                    (((_a = offer.legalPathIDP) === null || _a === void 0 ? void 0 : _a.legalModalPath) || offer.legal)) {
                    promotionIdexist = true;
                    legalURL = ((_c = (_b = offer.legalPathIDP) === null || _b === void 0 ? void 0 : _b.legalModalPath) === null || _c === void 0 ? void 0 : _c[0]) || offer.legal;
                    break;
                }
            }
        }
        if (promotionIdexist) {
            return (React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default('Link', 'See offer details'), "aria-label": 'See offer details Link', className: styles.offerDetailsLink, onClick: this.seeOfferDetailsBOGO.bind(this, legalURL) }, 'See offer details'));
        }
        else {
            return '';
        }
    };
    WirelessCartHelper.prototype.initializeEvents = function () {
        var _this = this;
        this.cartViewEvents = {
            onEdit: function () {
                var wirelessDetails = _this.stateManager.get(localdatastore_1.getNamespace('APPSHELL'), 'wirelessDetails');
                var editUrl = _this.isCommonCart ? _this.commonCartEditUrl : _this.cartMetaData.editUrl;
                var onEditURL = editUrl + ((wirelessDetails && wirelessDetails.experienceType
                    && _this.identifyPreapidCart()) ?
                    "?wlsview=" + wirelessDetails.experienceType : '');
                if (Utils.isLoginRequiredonCart()) {
                    onEditURL = Utils.getauthenticatedPersistantLoginURL(true);
                }
                _this.props.events.onEdit('WIRELESS', onEditURL);
            },
            onRemove: function () {
                _this.toggleRemoveModal();
            },
        };
    };
    WirelessCartHelper.prototype.seeOfferDetailsBOGO = function (legalurl) {
        this.getLegalContent(legalurl, this.bogoOfferModalLegalObj);
    };
    WirelessCartHelper.prototype.checkDuplicatePromo = function (lineItem) {
        var _this = this;
        var elements = [];
        var promoName = '';
        var duplicatePromoPrice = 0;
        lineItem.promotionReferences.forEach(function (promoRef, promoIndex) {
            var _a;
            var promotion = _this.cartData.promotions
                .find(function (promo) { return promo.id === promoRef; });
            if (promotion) {
                var promoPriceData = {
                    billingNote: _this.isExpressUp() ? '' : promotion.promotionCycle,
                    price: promotion.amount,
                };
                var promotionId = '';
                if (promotion.promotionCategory === 'STACKABLE_STANDALONE_PROMO' || promotion._intent === 'private') {
                    promotionId = promotion.upsellOfferId ? promotion.upsellOfferId : promotion.promotionId;
                }
                else {
                    promotionId = promotion.cmsPromotionId ? promotion.cmsPromotionId : promotion.promotionId;
                }
                if (!(_this.isAALFlow || _this.isMixedCart) && promoName === promotion.promotionName && promoIndex > 0) {
                    elements.pop();
                    promoPriceData.price = Number(promoPriceData.price) + Number(duplicatePromoPrice);
                    duplicatePromoPrice = promoPriceData.price;
                }
                if (promotion && promotion.promotionCategory && promotion.promotionCategory === 'ABPDiscount'
                    && promotion.phonesCount && promotion.alternativePromotionName && !_this.isMixAndMatch) {
                    var abpContent = _this.cartSummaryCMSData.abpDiscountLable || '';
                    promoName = abpContent.replace('{0}', String(promotion.phonesCount));
                }
                else if (promotion && promotion.promotionCategory && promotion.promotionCategory === 'ABPDiscount'
                    && promotion.alternativePromotionName && _this.isMixAndMatch) {
                    promoName = _this.cartSummaryCMSData.mixAndMatchAbpDiscountLable || '';
                }
                else {
                    promoName = promotion.promotionName;
                }
                duplicatePromoPrice = promoPriceData.price;
                elements.push(React.createElement("div", { key: promoIndex },
                    React.createElement(CartItemPromo_1.default, { data: {
                            isPriceNegative: true,
                            isSignaturePromo: _this.payload.enableSignatureEnhancedExperience &&
                                ((promotion === null || promotion === void 0 ? void 0 : promotion.promotionCategory) === 'iruPlanDiscount'
                                    || ((_a = promotion === null || promotion === void 0 ? void 0 : promotion.discountCategory) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'noncontractual'),
                            promoPrice: promoPriceData.price,
                            promoText: promoName,
                            promotionCycle: promoPriceData.billingNote,
                            showPrice: Number(promotion.amount) ? true : false,
                        }, options: { testId: utils_1.default('WRLS', "LineItem" + promoIndex) } }),
                    _this.matchPromoId(promotionId, promotion === null || promotion === void 0 ? void 0 : promotion.promotionCategory)));
            }
        });
        return elements;
    };
    WirelessCartHelper.prototype.displayPlanDetailsinModal = function (cartData) {
        var displayinModal = Utils.displayPlanDetailsinModal(cartData);
        return displayinModal;
    };
    WirelessCartHelper.prototype.renderAccessoryView = function (accessoryImageContainer, accesoryRtiOosMessage, accessoryDisplay, accessoryPriceView, isDeviceItems, lineDisplayName, isAccessory, losg, cartData, filteredLosgsData, accessoryLineItems) {
        var _this = this;
        var accessoryViewFragment = accessoryImageContainer.map(function (accessoryImage, index) {
            return (React.createElement(React.Fragment, { key: index },
                isDeviceItems.length > 0 && React.createElement("div", { className: styles.accessoryDivider }),
                accesoryRtiOosMessage[index],
                React.createElement("div", { className: [styles.newLosg, styles.displayFlex, styles.accessoryTileContainer].join(' ') },
                    accessoryImage,
                    React.createElement("div", { className: styles.deviceDetailContainer },
                        React.createElement("div", { className: _this.newWireless ? [styles.lineEditremoveContainer, styles.editRemoveAccessory].join(' ') : '' },
                            React.createElement(ui_components_1.Label, { data: { isDecodingRequired: false, text: '' }, options: { className: _this.newWireless ? styles.linename : styles.line }, testId: utils_1.default('WRLS', 'Accessory', "Header_" + index) }),
                            isAccessory && _this.showEditAndRemove(losg, cartData.qualifierPlanName, filteredLosgsData.length, index, null, true, accessoryLineItems[index])),
                        isDeviceItems.length === 0 && React.createElement("span", { className: [styles.flexView, styles.clear].join(' ') }, lineDisplayName),
                        React.createElement("span", { className: [styles.deviceName, styles.blockView, styles.clear].join(' ') }, accessoryPriceView[index]),
                        React.createElement("div", { className: [styles.flexView, styles.clear].join(' ') }, accessoryDisplay[index]))),
                React.createElement("div", { className: styles.blockView }, accessoryDisplay[index])));
        });
        return accessoryViewFragment;
    };
    WirelessCartHelper.prototype.getAccessoryImageContainers = function (losgItems, accessoryImageContainer) {
        var _this = this;
        losgItems.forEach(function (lineItem) {
            if (lineItem.uiDisplayLineItem && lineItem.itemType.toUpperCase() === 'ACCESSORY') {
                accessoryImageContainer.push(_this.displayAccessoryImage(lineItem));
            }
        });
        return accessoryImageContainer;
    };
    WirelessCartHelper.prototype.displayKonaEsimMsg = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.konaEsimMsg },
                " ",
                this.cartSummaryCMSData.konaDeviceESimCapable,
                " "),
            " ",
            React.createElement("br", null)));
    };
    WirelessCartHelper.CALL_SPO_ONLOAD = true;
    return WirelessCartHelper;
}(WirelessHelper_1.default));
exports.default = WirelessCartHelper;
//# sourceMappingURL=WirelessCartHelper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/WirelessCart/WirelessCartHelper.js
// module id = 769
// module chunks = 8